import { render, staticRenderFns } from "./AsociarTiposActividad.vue?vue&type=template&id=708436bb&"
import script from "./AsociarTiposActividad.vue?vue&type=script&lang=ts&"
export * from "./AsociarTiposActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports